import { ArrowRight } from 'lucide-react';

export function Projects() {
  const projects = [
    {
      title: "Cinematography & Filmmaking",
      description: "Cinematic storytelling through professional camera work, composition, and visual narrative. Creating compelling films that captivate audiences.",
      tags: ["Filmmaking", "Cinematography"]
    },
    {
      title: "Video Editing & Post-Production",
      description: "Expert color grading, visual effects, pacing, and animations. Transforming raw footage into polished, engaging content.",
      tags: ["Editing", "Post-Production"]
    }
  ];

  return (
    <section id="projects" className="bg-slate-950 py-20 px-6 border-t border-slate-900">
      <div className="max-w-7xl mx-auto">
        <h2 className="section-title mb-12">Featured Work</h2>
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {projects.map((project, idx) => (
            <div key={idx} className="card-dark hover:border-cyan-500/50 transition-all hover:shadow-lg hover:shadow-cyan-500/20 cursor-pointer group">
              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-cyan-400 transition-colors">{project.title}</h3>
              <p className="text-slate-400 mb-6">{project.description}</p>
              <div className="flex items-center gap-2 text-cyan-400 font-semibold">
                <span>View Project</span>
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="card-dark bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 border-cyan-500/30 py-12">
          <div className="text-center">
            <h3 className="text-3xl font-black text-white mb-2">BE YOURSELF!</h3>
            <h3 className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500 mb-2">BE DIFFERENT!</h3>
            <h3 className="text-3xl font-black text-white">BUILD DIFFERENT!</h3>
          </div>
        </div>
      </div>
    </section>
  );
}